export default {
  "and": "和",
  "Back": "后面",
  "Click to Expand": "单击展开",
  "Click to Hide": "单击隐藏",
  "Click to Highlight": "单击突出显示",
  "Click to Show": "单击显示",
  "Click to Show All": "单击显示全部",
  "Download": "下载",
  "Loading Visualization": "加载可视化",
  "more": "更多",
  "No Data Available": "无可用数据",
  "Powered by D3plus": "由 D3plus 提供支持",
  "Share": "共享",
  "Shift+Click to Hide": "Shift+单击隐藏",
  "Shift+Click to Highlight": "Shift+单击突出显示",
  "Total": "总",
  "Values": "值"
};
